/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getCameraImageByVIN = /* GraphQL */ `query GetCameraImageByVIN($cameraID: ID, $vin: String!) {
  getCameraImageByVIN(cameraID: $cameraID, vin: $vin) {
    timestamp
    value
  }
}
` as GeneratedQuery<
  APITypes.GetCameraImageByVINQueryVariables,
  APITypes.GetCameraImageByVINQuery
>;
export const getHealthStatus = /* GraphQL */ `query GetHealthStatus {
  getHealthStatus {
    status
  }
}
` as GeneratedQuery<
  APITypes.GetHealthStatusQueryVariables,
  APITypes.GetHealthStatusQuery
>;
export const getHub = /* GraphQL */ `query GetHub($id: ID!) {
  getHub(id: $id) {
    active
    address
    createdAt
    id
    name
    position {
      latitude
      longitude
    }
    updatedAt
  }
}
` as GeneratedQuery<APITypes.GetHubQueryVariables, APITypes.GetHubQuery>;
export const getMission = /* GraphQL */ `query GetMission($id: ID!) {
  getMission(id: $id) {
    actualArrivalTime
    actualStartTime
    createdAt
    description
    events {
      createdAt
      position {
        altitude
        heading
        latitude
        longitude
      }
      type
    }
    fleetId
    id
    name
    plannedArrivalTime
    progressDetails {
      eta
      remainingDistanceInMeters
      traveledDistanceInMeters
      updatedAt
    }
    route {
      createdAt
      durationInSeconds
      externalRouteId
      landingHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      launchHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      predefinedRouteId
      totalDistanceInMeters
      updatedAt
      waypoints {
        altitude
        heading
        latitude
        longitude
      }
    }
    state {
      updatedAt
      value
    }
    updatedAt
    vin
  }
}
` as GeneratedQuery<
  APITypes.GetMissionQueryVariables,
  APITypes.GetMissionQuery
>;
export const getUser = /* GraphQL */ `query GetUser($id: ID!) {
  getUser(id: $id) {
    city
    country
    createdAt
    updatedAt
    email
    firstName
    id
    lastName
    phone
    roles {
      id
      name
      createdAt
      updatedAt
      claims {
        pattern
        createdAt
        updatedAt
      }
      useWildcardClaims
    }
    status
    teams {
      id
      name
    }
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const getVehicleByVIN = /* GraphQL */ `query GetVehicleByVIN($vin: String!) {
  getVehicleByVIN(vin: $vin) {
    activeMissionId
    adsState
    cameras {
      id
      name
    }
    connectivityStatus {
      description
      expectedDisconnect
      latency
      reason
      state
    }
    createdAt
    customerId
    deviations {
      category
      description
      id
      isBlocking
      origin
      sentAt
      severity
      relatedDeviations
      resolvedAt
      state
    }
    drivingState
    externalId
    fleetId
    latestVehicleUpdate
    licensePlate
    mrmState {
      updatedAt
      startedAt
      value
      triggerBy
      mrmExecutionPhase
      mrmType
      causes {
        deviationId
      }
      error
    }
    name
    owners {
      email
      fullName
      id
      phoneNumber
      position
    }
    position {
      altitude
      heading
      latitude
      longitude
    }
    driverMode
    speedInKmh
    speedInMs
    updatedAt
    vin
    weightInKg
  }
}
` as GeneratedQuery<
  APITypes.GetVehicleByVINQueryVariables,
  APITypes.GetVehicleByVINQuery
>;
export const getVideoStreamingURL = /* GraphQL */ `query GetVideoStreamingURL($cameraID: String, $vin: String!) {
  getVideoStreamingURL(cameraID: $cameraID, vin: $vin) {
    cameraID
    streamingURL
    vin
  }
}
` as GeneratedQuery<
  APITypes.GetVideoStreamingURLQueryVariables,
  APITypes.GetVideoStreamingURLQuery
>;
export const listHubs = /* GraphQL */ `query ListHubs {
  listHubs {
    active
    address
    createdAt
    id
    name
    position {
      latitude
      longitude
    }
    updatedAt
  }
}
` as GeneratedQuery<APITypes.ListHubsQueryVariables, APITypes.ListHubsQuery>;
export const listRoutes = /* GraphQL */ `query ListRoutes {
  listRoutes {
    averageDuration
    createdAt
    distance
    id
    landingHub {
      active
      address
      createdAt
      id
      name
      position {
        latitude
        longitude
      }
      updatedAt
    }
    launchHub {
      active
      address
      createdAt
      id
      name
      position {
        latitude
        longitude
      }
      updatedAt
    }
    updatedAt
  }
}
` as GeneratedQuery<
  APITypes.ListRoutesQueryVariables,
  APITypes.ListRoutesQuery
>;
export const listUsers = /* GraphQL */ `query ListUsers {
  listUsers {
    city
    country
    createdAt
    updatedAt
    email
    firstName
    id
    lastName
    phone
    roles {
      id
      name
      createdAt
      updatedAt
      claims {
        pattern
        createdAt
        updatedAt
      }
      useWildcardClaims
    }
    status
    teams {
      id
      name
    }
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
export const listVehicles = /* GraphQL */ `query ListVehicles {
  listVehicles {
    activeMissionId
    adsState
    cameras {
      id
      name
    }
    connectivityStatus {
      description
      expectedDisconnect
      latency
      reason
      state
    }
    createdAt
    customerId
    deviations {
      category
      description
      id
      isBlocking
      origin
      sentAt
      severity
      relatedDeviations
      resolvedAt
      state
    }
    drivingState
    externalId
    fleetId
    latestVehicleUpdate
    licensePlate
    mrmState {
      updatedAt
      startedAt
      value
      triggerBy
      mrmExecutionPhase
      mrmType
      causes {
        deviationId
      }
      error
    }
    name
    owners {
      email
      fullName
      id
      phoneNumber
      position
    }
    position {
      altitude
      heading
      latitude
      longitude
    }
    driverMode
    speedInKmh
    speedInMs
    updatedAt
    vin
    weightInKg
  }
}
` as GeneratedQuery<
  APITypes.ListVehiclesQueryVariables,
  APITypes.ListVehiclesQuery
>;
export const listVehiclesByFleetId = /* GraphQL */ `query ListVehiclesByFleetId($fleetId: ID!) {
  listVehiclesByFleetId(fleetId: $fleetId) {
    activeMissionId
    adsState
    cameras {
      id
      name
    }
    connectivityStatus {
      description
      expectedDisconnect
      latency
      reason
      state
    }
    createdAt
    customerId
    deviations {
      category
      description
      id
      isBlocking
      origin
      sentAt
      severity
      relatedDeviations
      resolvedAt
      state
    }
    drivingState
    externalId
    fleetId
    latestVehicleUpdate
    licensePlate
    mrmState {
      updatedAt
      startedAt
      value
      triggerBy
      mrmExecutionPhase
      mrmType
      causes {
        deviationId
      }
      error
    }
    name
    owners {
      email
      fullName
      id
      phoneNumber
      position
    }
    position {
      altitude
      heading
      latitude
      longitude
    }
    driverMode
    speedInKmh
    speedInMs
    updatedAt
    vin
    weightInKg
  }
}
` as GeneratedQuery<
  APITypes.ListVehiclesByFleetIdQueryVariables,
  APITypes.ListVehiclesByFleetIdQuery
>;
export const getSystemTeamInfo = /* GraphQL */ `query GetSystemTeamInfo($id: ID!) {
  getSystemTeamInfo(id: $id) {
    id
    users {
      id
      firstName
      lastName
    }
    fleets {
      id
      name
    }
    createdAt
    updatedAt
  }
}
` as GeneratedQuery<
  APITypes.GetSystemTeamInfoQueryVariables,
  APITypes.GetSystemTeamInfoQuery
>;
export const listSystemTeams = /* GraphQL */ `query ListSystemTeams {
  listSystemTeams {
    id
    name
    numberOfUsers
    numberOfFleets
    createdAt
    updatedAt
  }
}
` as GeneratedQuery<
  APITypes.ListSystemTeamsQueryVariables,
  APITypes.ListSystemTeamsQuery
>;
export const listFleets = /* GraphQL */ `query ListFleets {
  listFleets {
    id
    name
    createdAt
    updatedAt
    teams {
      id
      name
    }
    numberOfVehicles
  }
}
` as GeneratedQuery<
  APITypes.ListFleetsQueryVariables,
  APITypes.ListFleetsQuery
>;
export const listRoles = /* GraphQL */ `query ListRoles {
  listRoles {
    id
    name
    createdAt
    updatedAt
    claims {
      pattern
      createdAt
      updatedAt
    }
    useWildcardClaims
  }
}
` as GeneratedQuery<APITypes.ListRolesQueryVariables, APITypes.ListRolesQuery>;
export const getFleetById = /* GraphQL */ `query GetFleetById($id: ID!) {
  getFleetById(id: $id) {
    fleetId
    vehicles {
      vin
      name
    }
  }
}
` as GeneratedQuery<
  APITypes.GetFleetByIdQueryVariables,
  APITypes.GetFleetByIdQuery
>;
export const getSystemVersion = /* GraphQL */ `query GetSystemVersion {
  getSystemVersion {
    version
    services {
      service
      version
    }
  }
}
` as GeneratedQuery<
  APITypes.GetSystemVersionQueryVariables,
  APITypes.GetSystemVersionQuery
>;
export const getMissionV2 = /* GraphQL */ `query GetMissionV2($id: ID!) {
  getMissionV2(id: $id) {
    ... on MissionV2 {
      id
      vin
      timestamp
      version
      actualArrivalTime
      actualStartTime
      description
      events {
        createdAt
        position {
          altitude
          heading
          latitude
          longitude
        }
        type
      }
      fleetId
      name
      plannedArrivalTime
      progressDetails {
        ttl
        value {
          eta
          remainingDistanceInMeters
          traveledDistanceInMeters
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
      route {
        createdAt
        durationInSeconds
        externalRouteId
        landingHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        launchHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        predefinedRouteId
        totalDistanceInMeters
        updatedAt
        positions {
          altitude
          heading
          latitude
          longitude
        }
      }
      state {
        ttl
        value {
          state
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
    }
    ... on ErrorResponse {
      statusCode
      errorCode
    }
  }
}
` as GeneratedQuery<
  APITypes.GetMissionV2QueryVariables,
  APITypes.GetMissionV2Query
>;
export const getActiveMissionV2 = /* GraphQL */ `query GetActiveMissionV2($vin: String!) {
  getActiveMissionV2(vin: $vin) {
    ... on MissionV2 {
      id
      vin
      timestamp
      version
      actualArrivalTime
      actualStartTime
      description
      events {
        createdAt
        position {
          altitude
          heading
          latitude
          longitude
        }
        type
      }
      fleetId
      name
      plannedArrivalTime
      progressDetails {
        ttl
        value {
          eta
          remainingDistanceInMeters
          traveledDistanceInMeters
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
      route {
        createdAt
        durationInSeconds
        externalRouteId
        landingHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        launchHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        predefinedRouteId
        totalDistanceInMeters
        updatedAt
        positions {
          altitude
          heading
          latitude
          longitude
        }
      }
      state {
        ttl
        value {
          state
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
    }
    ... on ErrorResponse {
      statusCode
      errorCode
    }
  }
}
` as GeneratedQuery<
  APITypes.GetActiveMissionV2QueryVariables,
  APITypes.GetActiveMissionV2Query
>;
export const getActiveMissionRouteV2 = /* GraphQL */ `query GetActiveMissionRouteV2($vin: String!) {
  getActiveMissionRouteV2(vin: $vin) {
    ... on GeneratedRouteV2 {
      createdAt
      durationInSeconds
      externalRouteId
      landingHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      launchHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      predefinedRouteId
      totalDistanceInMeters
      updatedAt
      positions {
        altitude
        heading
        latitude
        longitude
      }
    }
    ... on ErrorResponse {
      statusCode
      errorCode
    }
  }
}
` as GeneratedQuery<
  APITypes.GetActiveMissionRouteV2QueryVariables,
  APITypes.GetActiveMissionRouteV2Query
>;
export const getVehicleByVINV2 = /* GraphQL */ `query GetVehicleByVINV2($vin: String!) {
  getVehicleByVINV2(vin: $vin) {
    ... on VehicleV2 {
      vin
      timestamp
      activeMissionId {
        ttl
        value {
          data
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
      adsState {
        ttl
        value {
          state
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
      connectivityStatus {
        ttl
        value {
          expectDisconnection
          latency
          state
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
      deviations {
        ttl
        value {
          deviation {
            category
            description
            id
            isBlocking
            origin
            sentAt
            severity
            relatedDeviations
            resolvedAt
            state
          }
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
      driverMode {
        ttl
        value {
          mode
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
      drivingState {
        ttl
        value {
          state
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
      fleetId
      latestVehicleUpdate
      licensePlate
      mrmState {
        ttl
        value {
          data {
            value
            executionPhase
            causes
            startedAt
            triggerBy
            mrmType
          }
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
      name
      owners {
        email
        fullName
        id
        phoneNumber
        position
      }
      position {
        ttl
        value {
          position {
            altitude
            heading
            latitude
            longitude
          }
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
      speedMs {
        ttl
        value {
          speedMs
          updatedAt
        }
        error {
          type
          raisedAt
        }
      }
    }
    ... on ErrorResponse {
      statusCode
      errorCode
    }
  }
}
` as GeneratedQuery<
  APITypes.GetVehicleByVINV2QueryVariables,
  APITypes.GetVehicleByVINV2Query
>;
export const listVehiclesV2 = /* GraphQL */ `query ListVehiclesV2 {
  listVehiclesV2 {
    ... on VehicleList {
      items {
        vin
        timestamp
        activeMissionId {
          ttl
          value {
            data
            updatedAt
          }
          error {
            type
            raisedAt
          }
        }
        adsState {
          ttl
          value {
            state
            updatedAt
          }
          error {
            type
            raisedAt
          }
        }
        connectivityStatus {
          ttl
          value {
            expectDisconnection
            latency
            state
            updatedAt
          }
          error {
            type
            raisedAt
          }
        }
        deviations {
          ttl
          value {
            deviation {
              category
              description
              id
              isBlocking
              origin
              sentAt
              severity
              relatedDeviations
              resolvedAt
              state
            }
            updatedAt
          }
          error {
            type
            raisedAt
          }
        }
        driverMode {
          ttl
          value {
            mode
            updatedAt
          }
          error {
            type
            raisedAt
          }
        }
        drivingState {
          ttl
          value {
            state
            updatedAt
          }
          error {
            type
            raisedAt
          }
        }
        fleetId
        latestVehicleUpdate
        licensePlate
        mrmState {
          ttl
          value {
            data {
              value
              executionPhase
              causes
              startedAt
              triggerBy
              mrmType
            }
            updatedAt
          }
          error {
            type
            raisedAt
          }
        }
        name
        owners {
          email
          fullName
          id
          phoneNumber
          position
        }
        position {
          ttl
          value {
            position {
              altitude
              heading
              latitude
              longitude
            }
            updatedAt
          }
          error {
            type
            raisedAt
          }
        }
        speedMs {
          ttl
          value {
            speedMs
            updatedAt
          }
          error {
            type
            raisedAt
          }
        }
      }
    }
    ... on ErrorResponse {
      statusCode
      errorCode
    }
  }
}
` as GeneratedQuery<
  APITypes.ListVehiclesV2QueryVariables,
  APITypes.ListVehiclesV2Query
>;
export const listVehiclesByFleetIdV2 = /* GraphQL */ `query ListVehiclesByFleetIdV2($fleetId: ID!) {
  listVehiclesByFleetIdV2(fleetId: $fleetId) {
    ... on VehicleList {
      items {
        vin
        timestamp
        activeMissionId {
          ttl
          value {
            data
            updatedAt
          }
          error {
            type
            raisedAt
          }
        }
        adsState {
          ttl
          value {
            state
            updatedAt
          }
          error {
            type
            raisedAt
          }
        }
        connectivityStatus {
          ttl
          value {
            expectDisconnection
            latency
            state
            updatedAt
          }
          error {
            type
            raisedAt
          }
        }
        deviations {
          ttl
          value {
            deviation {
              category
              description
              id
              isBlocking
              origin
              sentAt
              severity
              relatedDeviations
              resolvedAt
              state
            }
            updatedAt
          }
          error {
            type
            raisedAt
          }
        }
        driverMode {
          ttl
          value {
            mode
            updatedAt
          }
          error {
            type
            raisedAt
          }
        }
        drivingState {
          ttl
          value {
            state
            updatedAt
          }
          error {
            type
            raisedAt
          }
        }
        fleetId
        latestVehicleUpdate
        licensePlate
        mrmState {
          ttl
          value {
            data {
              value
              executionPhase
              causes
              startedAt
              triggerBy
              mrmType
            }
            updatedAt
          }
          error {
            type
            raisedAt
          }
        }
        name
        owners {
          email
          fullName
          id
          phoneNumber
          position
        }
        position {
          ttl
          value {
            position {
              altitude
              heading
              latitude
              longitude
            }
            updatedAt
          }
          error {
            type
            raisedAt
          }
        }
        speedMs {
          ttl
          value {
            speedMs
            updatedAt
          }
          error {
            type
            raisedAt
          }
        }
      }
    }
    ... on ErrorResponse {
      statusCode
      errorCode
    }
  }
}
` as GeneratedQuery<
  APITypes.ListVehiclesByFleetIdV2QueryVariables,
  APITypes.ListVehiclesByFleetIdV2Query
>;
